export const GET_CHART_DATA = 'chart/GET_CHART_DATA';



// WEBPACK FOOTER //
// ./src/redux/Chart/constants.js